export function filterObject(obj, fn) {
    return Object.fromEntries(Object.entries(obj).filter(fn));
}
//# sourceMappingURL=filter-object.js.map